<template>
    <Dashboard
        :title="__('Product reviews', null, $page.props.profile_locale)"
    >
        <Heading
            :label="__('Product reviews', null, $page.props.profile_locale)"
            :backLink="route('dashboard.admin.products')"
            :description="'<span class=\'text-red-700\'>' + product.name + '</span>'"
        />

        <div class="overflow-auto w-full shadow-md rounded-md">
            <table class="w-full whitespace-nowrap">
                <thead class="relative">
                    <tr
                        class="text-xs font-semibold tracking-wide text-left text-gray-200 uppercase border-b bg-gray-900 border-red-700"
                    >
                        <th class="px-4 py-3">{{__('Name', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Aditional info', null, $page.props.profile_locale)}}</th>
                        <th class="px-4 py-3">{{__('Actions', null, $page.props.profile_locale)}}</th>
                    </tr>
                    <InertiaLink
                        :href="route('dashboard.admin.product.review.create', product.id)"
                        class="absolute top-1/2 right-2 transform -translate-y-1/2 rounded-full overflow-hidden hover:text-white text-gray-200"
                    >
                        <SvgIcon
                            name="plus-circle"
                            class="mx-auto "
                        />

                    </InertiaLink>
                </thead>
                <tbody class="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    <tr v-for="review in reviews" :key="review"
                        class="bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-400">
                        <td class="px-4 py-2 font-bold">
                            {{review.name}}
                        </td>
                        <td class="px-4 py-2">
                            {{review.addons}}
                        </td>
                        <td class="px-4 py-2 text-sm flex">
                            <IconLink
                                color="gray"
                                icon="pencil"
                                class="p-1 mr-1"
                                :href="route('dashboard.admin.product.review.edit', {
                                    product: product.id,
                                    review: review.id
                                })"
                            ></IconLink>
                            <IconLink
                                color="red"
                                icon="trash"
                                class="p-1 ml-auto"
                                :href="route('product.review.remove', review.id)"
                            ></IconLink>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!reviews.length" class="p-3">Produkt nie posiada opini</div>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import Heading from 'COMP/Heading';
import SvgIcon from 'UI/SvgIcon';
import IconLink from 'UI/IconLink';


export default {
    components: {
        Dashboard,
        Heading,
        SvgIcon,
        IconLink
    },

    props: ['reviews','product'],
}
</script>

<style>

</style>
